import { SOURCE_LINK_REL } from "../lib/meshmapperCoverage";

// The one plain link under a coverage legend's colour key: the map only paints coverage, so the details are one click away
// on the source's own site. Opens in a new tab and does not hand the new page this one (rel noopener noreferrer).
export function CoverageSourceLink({ link }: { link: { text: string; href: string } }) {
  return (
    <div className="legend-row coverage-source-link">
      <a href={link.href} target="_blank" rel={SOURCE_LINK_REL}>
        {link.text}
      </a>
    </div>
  );
}
